import { createSingleEntityStore } from '@core/ngrx-legacy';
import { GrowRole } from '@core/tellent-skills-types';

const { actions, reducer, namespace, selectors } = createSingleEntityStore<GrowRole[]>()(
  'GrowRoles',
  {
    customActions: adapter => ({
      fetch: state => adapter.markAsPending(state),
    }),
  },
);

export {
  actions as GrowRolesActions,
  reducer as GrowRolesReducer,
  selectors as GrowRolesSelectors,
  namespace as GrowRolesNamespace,
};
